import {ModelRepository, RequestMethod} from 'b302-frontend-library';

import Response from '../models/Response';
import {ResponseIndexRequest} from '../requests/Response';

interface FilterParams {
    contactable?: number;
}

class ResponsesRepository extends ModelRepository<Response> {

    constructor(university: number) {
        super(`universities/${university}/responses`);
    }

    public all(params?: FilterParams): Promise<Response[]> {
        return this.requestWithOptions<Response[]>(this.url(), RequestMethod.GET, {params}).send();
    }


    public allPaginated(request: ResponseIndexRequest) {
        return this.request<Response[]>(this.url(), RequestMethod.GET, {
            params: request,
        }).sendPagination();
    }
}

export default ResponsesRepository;
